import { TextInput } from '@src/common/components/TextInput';
import type { SearchPermitFilters } from '@src/permits/services/PermitApplicationClient';
import { useTranslation } from 'react-i18next';

export interface Props {
  onFilterChange: (filters: SearchPermitFilters) => void;
  value?: string;
}

export const TractorUnitNumberFilter = ({ onFilterChange, value }: Props) => {
  const { t } = useTranslation();

  return (
    <TextInput
      label={t('permitSearch.unitNumber')}
      value={value}
      onChange={(e) => {
        onFilterChange({ tractorUnitNumber: e.target.value as string });
      }}
    />
  );
};
